import addError from '../../../../utils/error.jsx';

export function request(price, oldPrice) {
    return {
        type: 'LADDERS_UPDATE_PRICE_REQUEST',
        price,
        oldPrice
    };
}

export function error(errors) {
    addError(errors);

    return {
        type: 'LADDERS_UPDATE_PRICE_ERROR',
        errors
    };
}

export function finish({prices}) {
    return (dispatch) => {
        dispatch({
            type: 'LADDERS_UPDATE_PRICE_FINISH',
            prices
        });

        dispatch({
            type: 'LADDERS_GET_LIST_REQUEST'
        });
    };
}
